import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-[#041047] py-24 lg:py-32 text-white">
      <div className="blur-blob bg-[#D1A5A5]/25 w-[420px] h-[420px] -top-32 -left-32" />
      <div className="blur-blob bg-[#CBBCE0]/25 w-[420px] h-[420px] -bottom-32 -right-32" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(212,175,55,0.06),_transparent_60%)]" />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <span className="eyebrow">Let’s grow together</span>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.1] tracking-tight">
          Ready To <em className="italic font-medium">Grow Your Business</em> Online?
        </h2>
        <p className="mt-6 text-lg md:text-xl text-white/75 max-w-2xl mx-auto leading-relaxed">
          Get a free consultation and discover how DDigital Studios can help you generate
          more leads and build a stronger online presence.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a href="#contact" data-testid="final-cta-book" className="btn-gold">
            Book Free Consultation <ArrowRight className="w-4 h-4" />
          </a>
          <a href="#services" data-testid="final-cta-services" className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white border-b border-white/30 hover:border-white pb-1 transition-all">
            Explore our services
          </a>
        </div>
      </div>
    </section>
  );
}
